import styled from 'styled-components';
import { Modal } from 'lib/components/Modal/Modal';

export const StyledCustomerUnclaimMachineModal = styled(Modal)`
  .ant-modal-footer {
    justify-content: space-between;
  }
`;
